import { SuretyAccountId, SuretyIndemnityAgreementId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import {
	accountIndemnityAgreementsQueryKey,
	accountLatestIndemnityAgreementQueryKey,
	accountQueryKey,
} from "../account.keys";

export const useAdminDeleteIndemnityAgreementFile = (
	accountId: SuretyAccountId,
	indemnityAgreementId: SuretyIndemnityAgreementId,
) => {
	const queryClient = useQueryClient();
	const { _delete } = useRequest();

	const mutation = useMutation({
		mutationKey: ["accounts", accountId, "indemnity-agreements", indemnityAgreementId, "file"],
		mutationFn: async () => {
			await _delete(
				`/v2/admin/surety/accounts/${accountId}/indemnity-agreements/${indemnityAgreementId}/file`,
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) });
			queryClient.invalidateQueries({
				queryKey: accountIndemnityAgreementsQueryKey(accountId, indemnityAgreementId),
			});
			queryClient.invalidateQueries({
				queryKey: accountLatestIndemnityAgreementQueryKey(accountId),
			});
		},
	});

	return {
		deleteIndemnityAgreementFile: mutation.mutate,
		deleteIndemnityAgreementFileIsLoading: mutation.isPending,
	};
};
